import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { City } from './types/City';
import { APIV2_URL } from './constants';

interface SearchCityParams {
  languages: string[];
  query: string;
}

interface CityLanguageMap {
  [key: string]: City;
}

export type SearchCityCall = (
  data: SearchCityParams,
) => Promise<{ data: CityLanguageMap }>;

export default (makeCall: MakeCall) => (data: SearchCityParams) =>
  makeCall<CityLanguageMap>('POST', `${APIV2_URL}/geonames/search-city`, {
    data,
  });
